/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusAsciiArtDto
 */
export interface NovitusAsciiArtDto {
    /**
     * Tekst pogrubiony
     * @type {boolean}
     * @memberof NovitusAsciiArtDto
     */
    bold?: boolean;
    /**
     * Odwrócone kolory
     * @type {boolean}
     * @memberof NovitusAsciiArtDto
     */
    invers?: boolean;
    /**
     * Wycentrowanie
     * @type {boolean}
     * @memberof NovitusAsciiArtDto
     */
    center?: boolean;
    /**
     * Wyrównanie do prawej
     * @type {boolean}
     * @memberof NovitusAsciiArtDto
     */
    right?: boolean;
    /**
     * Numer czcionki (0-2)
     * @type {number}
     * @memberof NovitusAsciiArtDto
     */
    font_number?: number;
    /**
     * Czcionka powiększona, zmniejsza o połowę ilość znaków mieszczących się w linii.
     * @type {boolean}
     * @memberof NovitusAsciiArtDto
     */
    big?: boolean;
    /**
     * Czcionka podwyższona x razy.
     * @type {number}
     * @memberof NovitusAsciiArtDto
     */
    height?: NovitusAsciiArtDtoHeightEnum;
    /**
     * Czcionka poszerzona x razy.
     * @type {number}
     * @memberof NovitusAsciiArtDto
     */
    width?: NovitusAsciiArtDtoWidthEnum;
    /**
     * Zawartość ASCII art
     * @type {string}
     * @memberof NovitusAsciiArtDto
     */
    text: string;
}


/**
 * @export
 */
export const NovitusAsciiArtDtoHeightEnum = {
    NUMBER_2: 2,
    NUMBER_4: 4
} as const;
export type NovitusAsciiArtDtoHeightEnum = typeof NovitusAsciiArtDtoHeightEnum[keyof typeof NovitusAsciiArtDtoHeightEnum];

/**
 * @export
 */
export const NovitusAsciiArtDtoWidthEnum = {
    NUMBER_2: 2,
    NUMBER_4: 4
} as const;
export type NovitusAsciiArtDtoWidthEnum = typeof NovitusAsciiArtDtoWidthEnum[keyof typeof NovitusAsciiArtDtoWidthEnum];


/**
 * Check if a given object implements the NovitusAsciiArtDto interface.
 */
export function instanceOfNovitusAsciiArtDto(value: object): value is NovitusAsciiArtDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function NovitusAsciiArtDtoFromJSON(json: any): NovitusAsciiArtDto {
    return NovitusAsciiArtDtoFromJSONTyped(json, false);
}

export function NovitusAsciiArtDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusAsciiArtDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bold': json['bold'] == null ? undefined : json['bold'],
        'invers': json['invers'] == null ? undefined : json['invers'],
        'center': json['center'] == null ? undefined : json['center'],
        'right': json['right'] == null ? undefined : json['right'],
        'font_number': json['font_number'] == null ? undefined : json['font_number'],
        'big': json['big'] == null ? undefined : json['big'],
        'height': json['height'] == null ? undefined : json['height'],
        'width': json['width'] == null ? undefined : json['width'],
        'text': json['text'],
    };
}

export function NovitusAsciiArtDtoToJSON(value?: NovitusAsciiArtDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bold': value['bold'],
        'invers': value['invers'],
        'center': value['center'],
        'right': value['right'],
        'font_number': value['font_number'],
        'big': value['big'],
        'height': value['height'],
        'width': value['width'],
        'text': value['text'],
    };
}

